import React from 'react';
import { Constants } from '@eagerdog/constants';
import { helperService } from 'src/services/helper.service';

import styles from './Wallet.module.scss';

const pointsToDollars = (points: number): string =>
  `$${(points / Constants.wallet.points_to_dollar_ratio).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

interface IProps {
  wallet: any
}

const Wallet: React.FC<IProps> = (props) => {
  const user = helperService.getUser();

  return(
    <div className={styles.Wallet}>
      <div className={styles.walletContent}>
        <h2>My Wallet</h2>
        
        <div className={styles.totalSection}>
          <div className={styles.totalPoints}>
            <h3>Total Points</h3>
            <div className={styles.totalValueRow}>
              <div className={styles.totalValue}>{props.wallet.total_points.toLocaleString()} pts</div>
              <div className={styles.totalValue}>{pointsToDollars(props.wallet.total_points)}</div>
            </div>
          </div>
        </div>

        <div className={styles.clubPointsSection}>
          <h4>Club Awarded Points</h4>
          <p className={styles.clubPointsSubtext}>Earn points from clubs by volunteering or helping out — then apply them at checkout to save on your entries!</p>
          {props.wallet?.clubs && props.wallet.clubs.length > 0 ? (
            <div className={styles.clubPointsTable}>
              <div className={styles.tableHeader}>
                <div>Club</div>
                <div>Points</div>
              </div>
              {props.wallet.clubs.map((club: any) => (
                <div key={club._id} className={styles.tableRow}>
                  <div className={styles.clubName}>{club.club_name}</div>
                  <div className={styles.clubPoints}>
                    <span>{club.points.toLocaleString()} pts</span>
                    <span className={styles.clubDollars}>{pointsToDollars(club.points)}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.noClubPoints}>
              <p>You don't have points with any clubs yet.</p>
              <p>Volunteer with clubs to earn points!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Wallet;